var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[_c('Navigation'),_c('div',{staticClass:"dashboard__inner"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }